import { StoreState } from "../../store/store.interface";

export const getLaunchConnectUrl = (state: StoreState) => state.connectLaunchState.data?.launch_url;

export const getLaunchConnectStatus = (state: StoreState) => state.connectLaunchState.status;

export const getLaunchConnectError = (state: StoreState) => state.connectLaunchState.error;
